import { mapActions } from 'vuex'

export default {
  ...mapActions(['setupJWT', 'updateUserData', 'setupUser']),
  doLogin () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    const credentials = {...this.credentials}
    if (this.credentials.type === 'professional') {
      delete credentials.country_register
    } else {
      credentials.country_register = credentials.countryregister
      delete credentials.document
      delete credentials.state
    }

    const setUserData = (data) => {
      Promise.all([
        this.updateUserData(data.user),
        this.setupJWT(data.token)
      ])
        .then(() => {
          this.setupUser()
            .then(() => {
              return this.$router.push({name: 'professional.dashboard.company.index'})
            })
        })
        .catch(({data, meta}) => {
          this.loginFail = true
        })
    }

    this.$resource.post('', credentials)
      .then(({data}) => {
        console.log(data)
        setUserData(data)
      })
      .catch(({data, meta}) => {
        this.loginFail = true
      })
  },
  goToLoadingPageProfessional () {
    location.href = this.URL_LOADING_PAGE_PROFESSIONAL
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/company/resources/methods.js